module.exports = __webpack_public_path__ + "img/type-strikethrough-01.d988cab1.svg";